'use strict';

export default class NewsletterFormHandler
{
    constructor() {
    //    newsletter_form
    //     alert('heee')
        this.newsletter_form = document.getElementById('newsletter_form');
        this.sendData = this.onSendData.bind(this);
        // this.handleResponse = this.onHandleResponse.bind(this);

        this.newsletter_form.addEventListener('submit', this.sendData);
    }

    onSendData(evt) {
        evt.preventDefault();

        let firstName = evt.target.querySelector('input[name="firstName"]').value;
        let email = evt.target.querySelector('input[name="email"]').value;
        let crsf_token = evt.target.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value;
        let hiddenField = evt.target.querySelector('input[name="hiddenField"]').value;
        let hcaptchaResponse = evt.target.querySelector('[name="h-captcha-response"]')?.value || '';
        if (!hcaptchaResponse && typeof hcaptcha !== 'undefined') {
            hcaptchaResponse = hcaptcha.getResponse();
        }

        this.ajaxRequest(firstName, email, crsf_token, hiddenField, hcaptchaResponse)
            .then(response => {
                this.onHandleResponse(response);
            })
            .catch(error => {
                if (error && error.errors) {
                    this.onHandleResponse(error);
                    return;
                }

                let newsletter_error = this.newsletter_form.querySelector('#newsletter_error');
                newsletter_error.classList.remove('d-none');
                newsletter_error.innerHTML = "Er is een onbekende fout opgetreden. ";
            });
    }

    addErrorsToField(fieldName, errors) {
        let error_element = this.newsletter_form.querySelector('#'+fieldName+'_error');
        error_element.classList.remove('d-none');
        error_element.innerHTML = errors.join("<br>");
    }

    onHandleResponse(response) {
        let data = response;

        if(Object.keys(data.errors).length) {
            for (let key in data.errors) {
                this.addErrorsToField(key, data.errors[key])
            }
            return;
        }
        let newsletter_success = this.newsletter_form.querySelector('#newsletter_success');
        newsletter_success.classList.remove('d-none');
        newsletter_success.innerHTML = data.success;

        let newsletter_subscribe_form = this.newsletter_form.querySelector('#newsletter_subscribe_form');
        newsletter_subscribe_form.classList.add('d-none');
    }

    ajaxRequest(firstName, email, crsf_token, hiddenField, hcaptchaResponse) {
        return new Promise((resolve, reject) => {
            const http = new XMLHttpRequest();
            http.responseType = 'json';

            const formData = new FormData();
            formData.append('CRAFT_CSRF_TOKEN', crsf_token);
            formData.append('firstName', firstName);
            formData.append('email', email);
            formData.append('hiddenField', hiddenField);
            formData.append('h-captcha-response', hcaptchaResponse);

            http.onload = () => {
                if (http.readyState === 4 && http.status === 200) {
                    resolve(http.response);
                } else if (http.readyState === 4 && http.status !== 200) {
                    reject(http.response);
                }
            };

            const encoded = new URLSearchParams(formData).toString();
            http.open('POST', '/kvbm/newsletter/subscribe');
            http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            http.send(encoded);
        });
    }
}
